import React from "react"
import {
    StayInTouchArea,
    StayInTouchBox,
    SingleTouchCol,
    SingleTouch,
    TouchSocailIcon,
    TouchTitle,
} from "./style"

const StayInTouchs = () => {
    return (
        <StayInTouchArea>
            <div className="section-title">
                <h3>Permanece en contacto</h3>
            </div>
            <StayInTouchBox>
                <SingleTouchCol>
                    <SingleTouch className="facebook" href="https://www.facebook.com/crdascz/">
                        <TouchSocailIcon className="socail-icon">
                            <i className="icofont-facebook"></i>
                        </TouchSocailIcon>
                        {/*<TouchTitle>5,685K</TouchTitle>*/}
                    </SingleTouch>
                </SingleTouchCol>
                <SingleTouchCol>
                    <SingleTouch className="twitter" href="https://twitter.com/crdascz">
                        <TouchSocailIcon className="socail-icon">
                            <i className="icofont-twitter"></i>
                        </TouchSocailIcon>
                        {/*<TouchTitle>5,685K</TouchTitle>*/}
                    </SingleTouch>
                </SingleTouchCol>
                <SingleTouchCol>
                    <SingleTouch className="behance" href="https://www.instagram.com/crda_scz/">
                        <TouchSocailIcon className="socail-icon">
                            <i className="icofont-instagram"></i>
                        </TouchSocailIcon>
                        {/*<TouchTitle>5,685K</TouchTitle>*/}
                    </SingleTouch>
                </SingleTouchCol>
                <SingleTouchCol>
                    <SingleTouch className="youtube-play" href="https://www.youtube.com/channel/UC9M4QVWNnppHXhdcM2EjvgQ">
                        <TouchSocailIcon className="socail-icon">
                            <i className="icofont-youtube-play"></i>
                        </TouchSocailIcon>
                        {/*<TouchTitle>5,685K</TouchTitle>*/}
                    </SingleTouch>
                </SingleTouchCol>
                <SingleTouchCol>
                    <SingleTouch className="linkedin" href="https://wa.me/message/WHIWB35TAIDSB1">
                        <TouchSocailIcon className="socail-icon">
                            <i className="icofont-whatsapp"></i>
                        </TouchSocailIcon>
                        {/*<TouchTitle>5,685K</TouchTitle>*/}
                    </SingleTouch>
                </SingleTouchCol>
                {/*<SingleTouchCol>*/}
                {/*    <SingleTouch className="linkedin" href="#!">*/}
                {/*        <TouchSocailIcon className="socail-icon">*/}
                {/*            <i className="icofont-linkedin"></i>*/}
                {/*        </TouchSocailIcon>*/}
                {/*        <TouchTitle>5,685K</TouchTitle>*/}
                {/*    </SingleTouch>*/}
                {/*</SingleTouchCol>*/}
            </StayInTouchBox>
        </StayInTouchArea>
    )
}

export default StayInTouchs
